import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importReactConfetti = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "ReactConfetti" */
                'react-confetti'
            ),
    );
